import { UnitAmount } from '@/domain/stripe/couponCode/model/UnitAmount'

export class CouponInput {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly amountOff: UnitAmount,
  ) {
  }
}
